module.exports = __webpack_public_path__ + "static/plant-in-rental-car-8a59f95ed93d83e18e4b93a95f565159.jpg";